import src from "IMAGE";
export default { src, width: 392, height: 762, blurWidth: 0, blurHeight: 0};
